"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9388],{

/***/ 56861:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
}), 'AddAPhoto');

exports.Z = _default;

/***/ }),

/***/ 50594:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

exports.Z = _default;

/***/ }),

/***/ 63441:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(91941);

__webpack_unused_export__ = ({
  value: true
});
exports.Z = void 0;

var _createSvgIcon = _interopRequireDefault(__webpack_require__(64938));

var _jsxRuntime = __webpack_require__(85893);

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"
}), 'Download');

exports.Z = _default;

/***/ }),

/***/ 24714:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ ModalImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70865);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73224);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(80562);
/* harmony import */ var _mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(50594);
/* harmony import */ var _mui_icons_material_Download__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63441);







var Modal = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
});
var ImageModalContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("div")({
    position: "relative"
});
var ImageModal = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("img", {
    shouldForwardProp: function(prop) {
        return prop !== "isProduct";
    }
})(function(param) {
    var isProduct = param.isProduct;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, isProduct ? {
        maxWidth: "90dvw",
        maxHeight: "90dvh"
    } : {
        maxWidth: "75dvw",
        maxHeight: "90dvh"
    });
});
var PdfImage = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("object")({
    width: "75vw",
    height: "90dvh",
    objectFit: "cover"
});
var DeleteIconButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    backgroundColor: "rgb(50, 49, 54)",
    color: "white",
    height: "35px",
    width: "35px",
    position: "absolute",
    top: "8px",
    right: "8px"
});
var CloseIconSized = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_icons_material_Close__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
    fontSize: "25px"
});
var DownloadIconButton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
    backgroundColor: "rgb(50, 49, 54)",
    color: "white",
    height: "35px",
    width: "35px",
    position: "absolute",
    bottom: "8px",
    right: "8px",
    cursor: "pointer",
    borderRadius: "50%"
});
var DownloadIconSized = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_mui_icons_material_Download__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
    fontSize: "25px"
});
function ModalImage(props) {
    var imageModal = props.imageModal, setImageModal = props.setImageModal, imageUrl = props.imageUrl, handleImageError = props.handleImageError, productName = props.productName, isProduct = props.isProduct;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Modal, {
            open: imageModal,
            onClose: function() {
                return setImageModal(false);
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(ImageModalContainer, {
                children: [
                    !(imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.includes(".pdf")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageModal, {
                                src: imageUrl,
                                alt: "Foto ".concat(productName),
                                onError: handleImageError,
                                isProduct: isProduct
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DeleteIconButton, {
                                onClick: function() {
                                    return setImageModal(false);
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CloseIconSized, {})
                            }),
                            !isProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DownloadIconButton, {
                                onClick: function() {
                                    return window.open(imageUrl, "_blank");
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(DownloadIconSized, {})
                            })
                        ]
                    }),
                    (imageUrl === null || imageUrl === void 0 ? void 0 : imageUrl.includes(".pdf")) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(PdfImage, {
                            data: imageUrl,
                            type: "application/pdf",
                            title: "Contenedor"
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 43236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dt": function() { return /* binding */ UploadImageMessageContainer; },
/* harmony export */   "Eo": function() { return /* binding */ ErrorMessageContainer; },
/* harmony export */   "Iu": function() { return /* binding */ AddImageDiv; },
/* harmony export */   "JA": function() { return /* binding */ UploadButtonText; },
/* harmony export */   "N_": function() { return /* binding */ AddImageInput; },
/* harmony export */   "SQ": function() { return /* binding */ UploadImageMessage; },
/* harmony export */   "U2": function() { return /* binding */ UploadImageTextError; },
/* harmony export */   "fV": function() { return /* binding */ UploadImagesScrollContainer; },
/* harmony export */   "j4": function() { return /* binding */ UploadButtonIcon; },
/* harmony export */   "qu": function() { return /* binding */ UploadButtonDiv; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70865);
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29630);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(80562);



var UploadImageMessageContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    padding: "8px 8px 8px 0"
});
var UploadImageMessage = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(param) {
    var theme = param.theme;
    return {
        fontWeight: 400,
        fontSize: "14px",
        letterSpacing: "0.15px",
        color: theme.palette.text.primary
    };
});
var UploadImagesScrollContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    overflowX: "scroll",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: "28px"
});
var AddImageInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input")({
    display: "none"
});
var AddImageDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")(function(props) {
    return {
        width: "100px",
        height: "100px",
        display: "flex",
        borderRadius: "10px",
        position: "relative",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
        border: props.error ? "1px dashed #D32F2F" : "1px dashed #0277BD",
        backgroundColor: props.error ? "#fbeaea" : "#F9F9F9"
    };
});
var ErrorMessageContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    minHeight: "21px"
});
var UploadImageTextError = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    fontSize: "12px",
    color: "#D32F2F",
    textAlign: "left"
});
var UploadButtonDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "error";
    }
})(function(param) {
    var error = param.error;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "10px",
        cursor: "pointer",
        padding: "20px 0px"
    }, error ? {
        border: "1px solid #D32F2F",
        backgroundColor: "#fbeaea"
    } : {
        border: " 1px solid #0A7ABE",
        backgroundColor: "#EFF7FF"
    });
});
var UploadButtonIcon = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "error";
    }
})(function(param) {
    var error = param.error;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        padding: "0px"
    }, error ? {
        color: "#D32F2F"
    } : {
        color: "#0A7ABE"
    });
});
var UploadButtonText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "error";
    }
})(function(param) {
    var error = param.error;
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        fontFamily: "Poppins",
        fontWeight: 500,
        fontSize: "13px",
        lineHeight: "19.5px",
        letterSpacing: "0.16px",
        textAlign: "center",
        marginBottom: "12px",
        margin: 0
    }, error ? {
        color: "#D32F2F"
    } : {
        color: "#0A7ABE"
    });
});


/***/ }),

/***/ 99388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ UploadImage_UploadImage; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(50930);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/AddAPhoto.js
var AddAPhoto = __webpack_require__(56861);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/@apollo/client/utilities/graphql/storeUtils.js
var storeUtils = __webpack_require__(51761);
// EXTERNAL MODULE: ./src/components/ModalImage.tsx
var ModalImage = __webpack_require__(24714);
// EXTERNAL MODULE: ./src/queries/prescription/mutations/removePrescription.tsx
var removePrescription = __webpack_require__(87509);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/IconButton/IconButton.js + 1 modules
var IconButton = __webpack_require__(80562);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/Close.js
var Close = __webpack_require__(50594);
;// CONCATENATED MODULE: ./src/components/prescriptions/UploadImagesScroll.styles.ts



var UploadImageDiv = (0,styled/* default */.Z)("div")({
    width: "100px",
    height: "100px",
    display: "block",
    borderRadius: "10px",
    backgroundColor: "#F9F9F9",
    position: "relative",
    justifyContent: "flex-start",
    cursor: "pointer"
});
var UploadImage = (0,styled/* default */.Z)("object")({
    width: "100%",
    height: "100%",
    display: "block",
    objectFit: "cover",
    pointerEvents: "none",
    border: "1px solid #EAEAEA",
    borderRadius: "10px",
    "> *": {
        display: "flex"
    }
});
var DeleteIconButton = (0,styled/* default */.Z)(IconButton/* default */.Z)({
    backgroundColor: "#0277BD",
    color: "white",
    height: "20px",
    width: "20px",
    position: "absolute",
    top: "4px",
    right: "10px",
    "&:hover": {
        backgroundColor: "#0277BD"
    }
});
var CloseIconSized = (0,styled/* default */.Z)(Close/* default */.Z)({
    fontSize: "16px"
});
var UploadImageImagesDivLoading = (0,styled/* default */.Z)("div")({
    width: "100px",
    height: "100px",
    display: "flex",
    borderRadius: "10px",
    backgroundColor: "#F9F9F9",
    justifyContent: "center",
    alignItems: "center"
});

;// CONCATENATED MODULE: ./src/components/prescriptions/UploadImagesScroll.tsx








var defaultImage = "/assets/images/prescription-default-image.png";
var defaultPdfImage = "/assets/images/prescription-default-pdf-image.png";
function UploadImagesScroll(param) {
    var loading = param.loading, _allowRemove = param.allowRemove, allowRemove = _allowRemove === void 0 ? true : _allowRemove, _prescription = param.prescription, prescription = _prescription === void 0 ? {
        url: "",
        uuid: ""
    } : _prescription;
    if (loading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImageImagesDivLoading, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                size: 30,
                color: "primary"
            })
        });
    }
    var ref = (0,react.useState)(false), imageModal = ref[0], setImageModal = ref[1];
    var ref1 = (0,react.useState)(false), imageError = ref1[0], setImageError = ref1[1];
    var imageUrl = (0,react.useMemo)(function() {
        setImageError(false);
        return imageError ? defaultImage : prescription === null || prescription === void 0 ? void 0 : prescription.url;
    }, [
        prescription === null || prescription === void 0 ? void 0 : prescription.url,
        imageError
    ]);
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,removePrescription/* removePrescription */.Q)("removePrescription"), {
        variables: {
            params: {
                uuid: prescription.uuid
            }
        },
        update: function update(cache, param) {
            var data = param.data;
            cache.modify({
                id: cache.identify((0,storeUtils/* makeReference */.kQ)("ROOT_QUERY")),
                fields: {
                    pendingPrescriptions: function pendingPrescriptions(prescriptions, param) {
                        var readField = param.readField;
                        return prescriptions.filter(function(prescription) {
                            return readField("id", prescription) !== data.removePrescription.id;
                        });
                    }
                }
            });
        }
    }), 1), removePrescriptionMutation = ref2[0];
    var handleRemove = function(e) {
        e.stopPropagation();
        void removePrescriptionMutation();
    };
    var handleImageError = function() {
        setImageError(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadImageDiv, {
                onClick: imageUrl !== defaultImage ? function() {
                    return setImageModal(true);
                } : undefined,
                children: [
                    prescription.url.includes(".pdf") ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage, {
                        data: defaultPdfImage,
                        type: "image/png",
                        title: "Contenedor"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage, {
                        data: imageUrl,
                        type: "image/png",
                        title: "Contenedor"
                    }),
                    allowRemove && /*#__PURE__*/ (0,jsx_runtime.jsx)(DeleteIconButton, {
                        onClick: prescription.url ? handleRemove : null,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIconSized, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ModalImage/* ModalImage */.E, {
                imageModal: imageModal,
                setImageModal: setImageModal,
                imageUrl: imageUrl,
                handleImageError: handleImageError,
                productName: "Receta",
                isProduct: false
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/prescriptions/useUpload.ts + 2 modules
var useUpload = __webpack_require__(50191);
// EXTERNAL MODULE: ./src/components/prescriptions/UploadImage.styles.ts
var UploadImage_styles = __webpack_require__(43236);
// EXTERNAL MODULE: ./src/hooks/usePendingPrescriptions.ts + 1 modules
var usePendingPrescriptions = __webpack_require__(3618);
// EXTERNAL MODULE: ./src/components/Modal.tsx
var Modal = __webpack_require__(43354);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
;// CONCATENATED MODULE: ./src/components/prescriptions/UploadImage.tsx










function UploadImage_UploadImage(param) {
    var emptyImagesError = param.emptyImagesError, setEmptyImagesError = param.setEmptyImagesError, pendingPrescriptions = param.pendingPrescriptions, confirmText = param.confirmText, hasInsurance = param.hasInsurance;
    var ref = (0,useAuth/* useAuth */.a)(), user = ref.appUser;
    var associatedPrescriptions = (0,usePendingPrescriptions/* usePendingPrescriptions */.h)().associatedPrescriptions;
    var ref1 = (0,useUpload/* useUpload */.V)(), loadFile = ref1.loadFile, loadings = ref1.loadings, onAskForHelp = ref1.onAskForHelp, errorMessage = ref1.errorMessage, setErrorMessage = ref1.setErrorMessage;
    var ref2 = (0,react.useState)([]), files = ref2[0], setFiles = ref2[1];
    var ref3 = (0,react.useState)(false), isImageLoading = ref3[0], setIsImageLoading = ref3[1];
    var bigInputRef = (0,react.useRef)();
    var smallInputRef = (0,react.useRef)();
    var inputClick = (0,react.useCallback)(function() {
        var _current;
        ((_current = bigInputRef.current) !== null && _current !== void 0 ? _current : smallInputRef.current).click();
    }, [
        bigInputRef,
        smallInputRef
    ]);
    (0,react.useEffect)(function() {
        setFiles(pendingPrescriptions);
    }, [
        pendingPrescriptions
    ]);
    var loadingImages = Object.values(loadings).filter(Boolean);
    (0,react.useEffect)(function() {
        if ((loadingImages === null || loadingImages === void 0 ? void 0 : loadingImages.length) === 0) setIsImageLoading(false);
    }, [
        loadingImages
    ]);
    var prescriptions = (0,_to_consumable_array/* default */.Z)(pendingPrescriptions !== null && pendingPrescriptions !== void 0 ? pendingPrescriptions : []).concat((0,_to_consumable_array/* default */.Z)(associatedPrescriptions !== null && associatedPrescriptions !== void 0 ? associatedPrescriptions : [])).filter(Boolean);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage_styles/* UploadImageMessageContainer */.Dt, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage_styles/* UploadImageMessage */.SQ, {
                    children: hasInsurance ? "Recuerda subir foto de todos los productos que quieras reembolsar o requieran receta." : confirmText ? "Recuerda subir foto de todos los productos que necesitan recetas." : "Sube una foto donde se vea la receta completa."
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadImage_styles/* UploadImagesScrollContainer */.fV, {
                children: [
                    associatedPrescriptions === null || associatedPrescriptions === void 0 ? void 0 : associatedPrescriptions.map(function(prescription) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(UploadImagesScroll, {
                            prescription: prescription,
                            allowRemove: false
                        }, prescription === null || prescription === void 0 ? void 0 : prescription.id);
                    }),
                    files === null || files === void 0 ? void 0 : files.map(function(prescription) {
                        /*#__PURE__*/ return (0,jsx_runtime.jsx)(UploadImagesScroll, {
                            prescription: prescription
                        }, prescription === null || prescription === void 0 ? void 0 : prescription.id);
                    }),
                    loadingImages === null || loadingImages === void 0 ? void 0 : loadingImages.map(function(_, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImagesScroll, {
                            loading: true
                        }, index);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(UploadImage_styles/* AddImageDiv */.Iu, {
                        onClick: inputClick,
                        error: emptyImagesError,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage_styles/* AddImageInput */.N_, {
                                ref: smallInputRef,
                                type: "file",
                                accept: "image/*;capture=camera",
                                onChange: function(event) {
                                    void loadFile(event, setEmptyImagesError);
                                    setIsImageLoading(true);
                                }
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage_styles/* UploadButtonIcon */.j4, {
                                error: emptyImagesError,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddAPhoto/* default */.Z, {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage_styles/* ErrorMessageContainer */.Eo, {
                children: emptyImagesError && !isImageLoading && prescriptions.length === 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(UploadImage_styles/* UploadImageTextError */.U2, {
                    children: "Debes subir una receta para continuar"
                })
            }),
            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* AlertModal */.VF, {
                open: !!errorMessage,
                setOpen: function() {
                    return setErrorMessage(null);
                },
                title: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.title,
                content: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.description,
                actionsDirection: "row",
                actions: [
                    {
                        text: "Volver",
                        variant: "outlined",
                        onActionClick: function() {
                            setErrorMessage(null);
                        }
                    },
                    {
                        text: "Ayuda",
                        variant: "contained",
                        onActionClick: function() {
                            onAskForHelp(user.id);
                        }
                    }, 
                ]
            })
        ]
    });
}


/***/ }),

/***/ 3618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ usePendingPrescriptions; }
});

// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useQuery.js
var useQuery = __webpack_require__(71641);
// EXTERNAL MODULE: ./src/queries/order/queries/currentOrderWithPrescriptions.ts
var currentOrderWithPrescriptions = __webpack_require__(3073);
// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(92228);
// EXTERNAL MODULE: ./node_modules/@apollo/client/node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(68921);
;// CONCATENATED MODULE: ./src/queries/prescription/queries/lookForPrescriptions.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  query LookForPrescription {\n    lookForPrescriptions {\n      prescriptionRequired\n      associations {\n        orderDetail {\n          id\n          product {\n            id\n            prescriptionType\n          }\n          quantity\n        }\n        prescriptionId\n        prescription {\n          id\n          url\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var lookForPrescriptions = function() {
    return (0,lib/* gql */.Ps)(_templateObject());
};

// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
;// CONCATENATED MODULE: ./src/hooks/usePendingPrescriptions.ts





function usePendingPrescriptions() {
    var ref, ref1, ref2;
    var appUser = (0,useAuth/* useAuth */.a)().appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var ref3 = (0,useQuery/* useQuery */.a)((0,currentOrderWithPrescriptions/* currentOrderWithPrescriptions */.l)(), {
        returnPartialData: true,
        fetchPolicy: "cache-and-network",
        skip: !appUser
    }), prescriptionsData = ref3.data, prescriptionsLoading = ref3.loading;
    var productsWithPrescription = prescriptionsData === null || prescriptionsData === void 0 ? void 0 : (ref = prescriptionsData.currentOrder) === null || ref === void 0 ? void 0 : ref.orderDetails.filter(function(detail) {
        return detail.product.prescriptionType;
    }).map(function(detail) {
        return detail.product;
    });
    var ref4 = (0,useQuery/* useQuery */.a)(lookForPrescriptions(), {
        fetchPolicy: "cache-and-network",
        skip: !appUser
    }), lookForPrescriptionsData = ref4.data, prescriptionRequiredLoading = ref4.loading;
    var ref5;
    if (isLocalVendor || isAssistantUser) return {
        requirePrescriptions: false,
        enoughAssociationsFound: true,
        requirePrescriptionUpload: false,
        loading: false,
        pendingPrescriptions: (ref5 = prescriptionsData === null || prescriptionsData === void 0 ? void 0 : prescriptionsData.pendingPrescriptions) !== null && ref5 !== void 0 ? ref5 : [],
        associatedPrescriptions: []
    };
    var ref6;
    var requirePrescriptions = (ref6 = productsWithPrescription === null || productsWithPrescription === void 0 ? void 0 : productsWithPrescription.length) !== null && ref6 !== void 0 ? ref6 : 0;
    var requirePrescriptionUpload = productsWithPrescription === null || productsWithPrescription === void 0 ? void 0 : productsWithPrescription.some(function(product) {
        return product.prescriptionType !== "NOT_REQUIRED";
    });
    var ref7;
    var associationsAmount = (ref7 = lookForPrescriptionsData === null || lookForPrescriptionsData === void 0 ? void 0 : (ref1 = lookForPrescriptionsData.lookForPrescriptions) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.associations) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref7 !== void 0 ? ref7 : 0;
    var enoughAssociationsFound = associationsAmount == requirePrescriptions;
    var ref8, ref9;
    return {
        requirePrescriptions: requirePrescriptions,
        enoughAssociationsFound: enoughAssociationsFound,
        requirePrescriptionUpload: requirePrescriptionUpload,
        loading: prescriptionsLoading || prescriptionRequiredLoading,
        pendingPrescriptions: (ref8 = prescriptionsData === null || prescriptionsData === void 0 ? void 0 : prescriptionsData.pendingPrescriptions) !== null && ref8 !== void 0 ? ref8 : [],
        associatedPrescriptions: (ref9 = lookForPrescriptionsData === null || lookForPrescriptionsData === void 0 ? void 0 : lookForPrescriptionsData.lookForPrescriptions.associations.map(function(association) {
            return association.prescription;
        })) !== null && ref9 !== void 0 ? ref9 : []
    };
}


/***/ }),

/***/ 3073:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ currentOrderWithPrescriptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query currentOrderWithPrescriptions($params: CurrentOrderParams) {\n    currentOrder(params: $params) {\n      id\n      orderDetails {\n        id\n        quantity\n        price\n        product {\n          id\n          name\n          imagesUrl\n          unit\n          format\n          concentration\n          laboratory\n          prescriptionType\n          availability {\n            stock\n            statusWithoutStock\n            status\n          }\n        }\n        status\n        prescription {\n          id\n        }\n      }\n    }\n    pendingPrescriptions {\n      id\n      uuid\n      url\n    }\n    currentUserInfo {\n      id\n      createdAt\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var currentOrderWithPrescriptions = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 87509:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ removePrescription; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68921);
/*
 * File: createPrescription.tsx
 * Project: meki
 * File Created: Wednesday, 7th October 2020 12:51:25 pm
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Friday, 16th July 2021 2:32:55 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\nmutation ",
        "($params: RemovePrescriptionParams!){\n    removePrescription(params: $params){\n        id\n        uuid\n      }\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var removePrescription = function(name) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), name);
};


/***/ })

}]);